import { QueryCache, QueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useAuthStore } from './store/authStore';
import { addQueryError } from './stores/queryErrorStore';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      const meta = query.meta as { errorMessage?: string } | undefined;
      const message = meta?.errorMessage ?? error.message;

      // Only show error toast for admin users
      const user = useAuthStore.getState().user;
      if (user && (user.role === 'admin' || user.isAdmin)) {
        toast.error(message);
      }

      // Always log errors for debugging
      addQueryError({
        queryKey: query.queryKey,
        message,
        stack: error.stack,
      });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});
